import { setSelectedPage } from "./types";

export default function pageDataReducer(state, { type, payload }) {
  switch (type) {
    case setSelectedPage:
      return { ...state, selectedPage: payload.selectedPage };
    default:
      throw new Error(`Unknown action ${type} in pageDataReducer`);
  }
}